import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Button,  Header,  Label,  Segment } from "semantic-ui-react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import MyTextInput from "../../app/common/form/MyTextInput";
import MyDateInput from "../../app/common/form/MyDateInput";
import {MySelectInput, valor} from "../../app/common/form/MySelectInput";
import { toast, ToastContainer } from 'react-toastify';
import { CCTOperacion, CCTOperacionesFormValues } from "../../app/models/CCTOperacion";
import MyDateInputRange from "../../app/common/form/MyDateInputRange";
import MySelect, { MySelectEsp } from "../../app/common/form/MySelect";
import { useField } from "formik";

let cuentasPersona:any = []
let cuentaS:any = []
const trans: any = [] 
let llave:any = ""
let llave2:any = ""
let prueba:any
let enviar:any = ""
let elementss:any = 1

export default observer(function CreateOperacion() {
    const [persona, setPersona] = useState("");
    const [cuentas, setCuentas] = useState("");
    const history = useHistory();
    const {CCTOperacionStore, modalStore, CuentaDPIStore} = useStore();

    const [selectedOption, setSelectedOption] = useState(cuentaS[""]);
   
    

    const {createCCTOperacion, loading, dpiByCodigo, getTransacciones, TransaccionByCodigo, TransaccionRegistry, personaDPI, kk, inputPersona, CCTCuentaByCodigo} = CCTOperacionStore;

    let contador = 0
    const [cuenta, setCuenta] = useState(false);
    
    const [CCTOperacion, setCCTipoDeDocumento] = useState<CCTOperacionesFormValues>(new CCTOperacionesFormValues());
   
    const validationSchema = Yup.object({
         cuenta: Yup.string().required('Obligatorio'),
        // numeroTransaccion: Yup.string().required('Obligatorio'),
        fecha: Yup.date().required('Obligatorio'),
        valor: Yup.number().required('Obligatorio'),
        numeroDeDocumentoContable: Yup.number().required('Obligatorio'),
    })


    useEffect (()=>{
        elementss = 2
        myFunction()
        //console.log(elementss)
    }, [elementss])


    function myFunction() {   
              
       //console.log(cuentasPersona)
      } 
    
           
    function buscrPersona(){
        const valorInput = (document.getElementById("idCliente") as HTMLInputElement).value;
        if(valorInput.length == 13){
            personaDPI(valorInput)
            myFunction()
            elementss = 2            
        }
    }


    if (elementss == 2 ){

        if(CCTCuentaByCodigo.length >= 0){
        CCTCuentaByCodigo.map((cuenta) => {
            const c = {text: cuenta.cuenta.toString(), value: cuenta.cuenta.toString()}
            cuentasPersona.push(c)
            //console.log("ver variable", elementss)
          

        })      
         
                    
         var transXcuenta:any = []
         TransaccionByCodigo.map((movimientosPosibles) => {
        // if(movimientosPosibles.)
        var tran = {text: movimientosPosibles.descripcion, value: movimientosPosibles.id}
        transXcuenta.push(tran)             
        
    })
          
    }        
    }else if(elementss == 1 ){

        var transXcuenta:any = []
        TransaccionByCodigo.map((movimientosPosibles) => {
//       // if(movimientosPosibles.)
        var tran = {text: movimientosPosibles.descripcion, value: movimientosPosibles.id}
        transXcuenta.push(tran)             
       
})
        
    } 
    

    function handleFormSubmit(CCTOperacion : CCTOperacionesFormValues) {
        let date: Date = new Date();
        let id:any
        dpiByCodigo.map((personai:any) => {
            id = personai.id
            let newCCTipoDeCuenta:CCTOperacion = {
                idCliente: id,
                cuenta: CCTOperacion.cuenta,  
                numeroTransaccion: (document.getElementById('numeroTransaccion') as HTMLInputElement).value,
                fecha: CCTOperacion.fecha,
                valor: CCTOperacion.valor,
                numeroDeDocumentoContable: CCTOperacion.numeroDeDocumentoContable,
                estatusMovimiento: "AC",
                fechaRegistro: date,
                usuarioRegistro: "",
                fechaAnulado: date,
                usuarioAnulo: "",
                codigoTipoTransaccion: CCTOperacion.codigoTipoTransaccion,
                pagado: true,               
            };
           
            createCCTOperacion(newCCTipoDeCuenta).then(() => {
                toast.success("Se a guardado correctamente")
                               
                modalStore.closeModal()                
            });
        })
    }

   if (CCTOperacionStore.loadingInitial) return <LoadingComponent content='Cargando...' />

    return (
            <div className="pagina_formulario">
                <Segment className="contenedor_formulario">
                    <Formik validationSchema={validationSchema} 
                            enableReinitialize 
                            initialValues={CCTOperacion} 
                            onSubmit={values => handleFormSubmit(values)}>
                        {({handleSubmit, isValid, isSubmitting, dirty}) => (
                            <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                <Header size='large' content='Nuevo Movimiento' style={{color:  "#538cbe", fontFamily: "Gotham"}} />
                                <br></br>
                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="DPI" />
                                    <input name='idCliente' id="idCliente" maxLength={13} minLength={13} onChange={buscrPersona}></input>
                                    {inputPersona ? (
                                        <Label basic color='red'>No se encuentra registrado</Label>
                                    ): null}                                    
                    
                                </div>                      
                                  
                                            <Header size="small" content="Cuenta" />
                                            <MySelectInput name='cuenta' placeholder='' id='cuenta' options={cuentasPersona} />                          
                                                                      
                                <div>
                                    <Header size="small" content="Numero de boleta" />
                                    
                                    <input name='numeroTransaccion1' id='numeroTransaccion'  placeholder=''onChange={()=>{

                                        const valor = (document.getElementById('numeroTransaccion') as HTMLSelectElement).value
                                        if(valor.length == 1){
                                           
                                            const element : HTMLElement = (document.getElementById('cuenta') as HTMLElement);
                                            enviar = element.innerText.toString().split("-")
                                             getTransacciones(enviar[0])                                             
                                             elementss = 1                                                                              
                                        }else{
                                            
                                        }                                                             

                                    }}
                                     
                                    />
                                  
                                </div>

                                <div>
                                    <Header size="small" content="Tipo de Transaccion" />
                                    <MySelectInput id='codigoTipoTransaccion' name='codigoTipoTransaccion' placeholder='' options={transXcuenta} />
                                </div>

                                <div>
                                    <Header size="small" content="Fecha" />
                                    <MyDateInput id='fecha' name='fecha' placeholderText='' dateFormat='dd/MM/yyyy' />
                                </div>
                                <div>
                                    <Header size="small" content="Valor" />
                                    <MyTextInput name='valor' placeholder='' type="number"/>
                                </div>
                                <div>
                                    <Header size="small" content="Numero 63A" />
                                    <MyTextInput name='numeroDeDocumentoContable' placeholder='' type="number" />
                                </div>
                                <br></br>
                                <div>
                                    <Button
                                        loading={loading} 
                                        disabled={!isValid || !dirty || isSubmitting}
                                        type='submit' 
                                        content='Guardar' 
                                        style={{backgroundColor: "#15b3e8", color: "white"}}/>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Segment>
        </div>
    )
})

